import { QuestionTypeEnum } from '@/models/Question';
import { QuestionViewPropsFor } from '@/components/question/view/types';
import { getTranslatableValue } from '@/utils/translatable-field/getTranslatableValue';
import { useQuestionView } from '../../context/QuestionViewContext';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { ReviewingFlashcardView } from '../../primitives/standard/ReviewingFlashcardView';
import { AnsweringFlashcardView } from '../../primitives/standard/AnsweringFlashcardView';
import { useFlashcardAnswer } from './useFlashcardAnswer';

export function FlashcardAnswerView(
  props: QuestionViewPropsFor<QuestionTypeEnum.FLASHCARD>,
) {
  const { question } = props;
  const { language } = useQuestionView();
  const {
    showBack,
    revealBack,
    mode,
    options,
    disabled,
    selectedValues,
    handleChange,
  } = useFlashcardAnswer(props);

  const frontContent = getTranslatableValue(question.frontContent, language);
  const showFrontOnBack = question.showFrontOnBack;
  const backContent = getTranslatableValue(question.backContent, language);

  return (
    <div className="w-full flex flex-col items-center justify-center gap-x-4 gap-y-6">
      <ConditionalRenderer condition={mode === 'reviewing'}>
        <ReviewingFlashcardView
          frontContent={frontContent}
          backContent={backContent}
          showFrontOnBack={showFrontOnBack}
        />
      </ConditionalRenderer>

      <ConditionalRenderer condition={mode === 'answering'}>
        <AnsweringFlashcardView
          frontContent={frontContent}
          backContent={backContent}
          showFrontOnBack={showFrontOnBack}
          showBack={showBack}
          revealBack={revealBack}
          selectedValues={selectedValues}
          handleChange={handleChange}
          options={options}
          disabled={disabled}
        />
      </ConditionalRenderer>
    </div>
  );
}
